import React from "react";

import { Alert, AlertProps, Box } from "@mui/material";

import { InformationCircleIcon } from "../Icons/InformationCircle";

export const Hint = ({
  hintValue,
  ...props
}: {
  hintValue: React.ReactNode;
} & AlertProps) => {
  const iconMapping = {
    success: (
      <Box
        component={InformationCircleIcon}
        width={16}
        height={16}
        sx={{ "&&": { color: "success.light" } }}
      />
    ),
    info: (
      <Box
        component={InformationCircleIcon}
        width={16}
        height={16}
        sx={{ "&&": { color: "secondary.main" } }}
      />
    ),
    warning: (
      <Box
        component={InformationCircleIcon}
        width={16}
        height={16}
        sx={{ "&&": { color: "warning.light" } }}
      />
    ),
    error: (
      <Box
        component={InformationCircleIcon}
        width={16}
        height={16}
        sx={{ "&&": { color: "error.light" } }}
      />
    ),
  };

  return (
    <Alert
      variant={"filled"}
      iconMapping={iconMapping}
      sx={{ textAlign: "left" }}
      {...props}
    >
      {hintValue}
    </Alert>
  );
};
